/*
 * @Author: changcheng
 * @LastEditTime: 2023-11-06 16:05:14
 */
import "./_style.scss";
import learnCourseQr from "@root/img/learnCourseQr.png";
import learnQuestionQr from "@root/img/learnQuestionQr.png";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
const hideArray = ["/login", "/register", "/iframeComponent"];
export default function Footer() {
  let { pathname } = useLocation();
  const [hide, setHide] = useState(false);
  useEffect(() => {
    setHide(!hideArray.includes(pathname));
  }, [pathname]);
  return (
    <>
      {hide && (
        <div className="footer">
          <div>
            <p>
              指导单位：国家卫生健康委医政司&emsp;国家卫生健康委卫生发展研究中心
            </p>
            <p>技术支持：医视界</p>
          </div>
          <div className="qr-container">
            <div className="text-container">
              <img src={learnQuestionQr} alt="" />
              <div>
                <p>移动端学习课程</p>
                <p>扫描二维码直接观看</p>
              </div>
            </div>
            <div className="text-container">
              <img src={learnCourseQr} alt="" />
              <div>
                <p>学习问题答疑</p>
                <p>扫描二维码联系客服</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
